import type { FC, ReactElement } from 'react';

import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { ChartsValueDataTypes } from '../StatsCharts';

import styles from './ChartsLineView.module.css';

interface ChartsLineViewProps {
  data: ChartsValueDataTypes;
}

export const ChartsLineView: FC<ChartsLineViewProps> = ({ data: { percentage } }): ReactElement => {
  const percentageValue = Number(percentage);
  const widthPercentage = `${percentageValue}%`;
  const mods = useModifiers(styles, 'zero_percent', {
    charts_line: percentageValue === 0,
  });

  return (
    <div className={styles.charts_line_box}>
      <div className={styles.charts_line_left} style={{ width: widthPercentage }}></div>
      <div className={`${styles.charts_line_right} ${mods}`} style={{ width: `${100 - percentageValue}%` }}></div>
    </div>
  );
};
